import React, { useEffect, useState } from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import OpportunityService from '../../../../Services/opportunityService';
import ErrorMessage from '../../../ErrorMessage';

export default function OpportunitySelect(props) {
  const [selectValues, setSelectValues] = useState([]);

  useEffect(() => {
    if (!props.idFilter) {
      setSelectValues([]);
      return;
    }
    OpportunityService.GetOpportunityByClientIds([props.idFilter.toString()])
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .forEach((opportunity) => {
            optValues.push({
              label: `${opportunity.opportunityId} - ${opportunity.name}`,
              value: opportunity.opportunityId,
              disabled: false,
            });
          });
        setSelectValues(optValues);
      })
      .catch((ex) => {
        setSelectValues([]);
        ErrorMessage.SetErrorMessage('OSEL34', ex);
      });
  }, [props.idFilter]);

  return (
    <SelectFieldCheckbox
      value={props.value}
      className={props.className}
      fieldName={props.fieldName}
      onChange={props.onChange}
      filterCleared={props.filterCleared}
      selectValues={selectValues}
    />
  );
}
